import { collectionMetadata } from "../collectionMetadata";
import { generateUUID } from "../private/generateUuid";
import type { ImmediateEvent, LazyEvent, Transporter } from "../types";

declare global {
  interface Window {
    AndroidFunction?: {
      messageHandler: (json: string) => void;
    };
    webkit?: {
      messageHandlers: {
        messageHandler: {
          postMessage: (message: string) => void;
        };
      };
    };
  }
}

interface AnalyticsMessage {
  id: string;
  type: "REQ.ANALYTICS.LOG_EVENT";
  payload: {
    analytics: {
      target: "KARROT";
      name: string;
      params: string;
    };
  };
}

const BRIDGE_METHOD = "REQ.ANALYTICS.LOG_EVENT" as const;
const ANALYTICS_TARGET = "KARROT" as const;

export class KarrotAnalyticsTransporter implements Transporter {
  private readonly eventName: string;

  constructor(eventName: string) {
    this.eventName = eventName;
  }

  send(event: ImmediateEvent | LazyEvent): void {
    const message: AnalyticsMessage = {
      id: generateUUID(),
      type: BRIDGE_METHOD,
      payload: {
        analytics: {
          target: ANALYTICS_TARGET,
          name: this.eventName,
          params: JSON.stringify({
            ...event,
            ...collectionMetadata("webview"),
          }),
        },
      },
    };

    const messageString = JSON.stringify(message);
    if (window.AndroidFunction?.messageHandler) {
      window.AndroidFunction.messageHandler(messageString);
    } else if (window.webkit?.messageHandlers?.messageHandler) {
      window.webkit.messageHandlers.messageHandler.postMessage(messageString);
    } else {
      console.warn(
        "[xview_perf] Native bridge not found. Message was not delivered.",
      );
    }
  }
}
